<template>
    <div class="tabs-form">
        <div class="tabs">
            <div v-for="item in identity" :key="item.id" @click="handlePrivateClick(item.id)"
                :class="['tabs-pane', tabId == item.id && 'tabs-pane-avtive']">
                {{ item.name }}
            </div>
        </div>


        <el-form :inline="true" class="form" ref="form" :model="form">
            <div class="form-contain">
                <el-form-item prop="title">
                    <InputTopTip v-model="form.title" placeholder="名称">
                        <el-input v-model="form.title" size="small" class="width-264" placeholder=""
                            @keyup.native.enter="; (page = 1), getRemindDesc()"></el-input>
                    </InputTopTip>
                </el-form-item>
                <el-form-item prop="publisher_id">
                    <InputTopTip v-model="form.publisher_id" placeholder="出版社">
                        <el-select v-model="form.publisher_id" size="small" placeholder="" class="width-166"
                            @change="formChange($event, '出版社')">
                            <el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </InputTopTip>
                </el-form-item>
                <el-form-item prop="textbook_id">
                    <InputTopTip v-model="form.textbook_id" placeholder="教材">
                        <el-select v-model="form.textbook_id" size="small" :disabled="!!!form.publisher_id"
                            placeholder="" class="width-166" @change="formChange($event, '教材')">
                            <el-option v-for="item in textbookTags" :key="item.id" :label="item.text_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </InputTopTip>
                </el-form-item>
                <el-form-item prop="dict_ids">
                    <InputTopTip v-model="form.dict_ids" placeholder="目录">
                        <el-cascader :disabled="!!!form.textbook_id" v-model="form.dict_ids" :props="{
                            value: 'id',
                            label: 'direct_name',
                            expandTrigger: 'click'
                        }" :options="dictIdTags" :show-all-levels="false" placeholder="" size="small" class="width-166"
                            @change="formChange($event, '目录')"></el-cascader>
                    </InputTopTip>
                </el-form-item>
            </div>

            <el-form-item class="form-reset">
                <el-button type="primary" @click="; (page = 1), getRemindDesc()" size="small" class="action-btn"
                    style="width: 70px; margin-right: 15px;">搜索</el-button>
                <el-button @click="resetForm('form')" size="small" style="width: 70px;">重置</el-button>
            </el-form-item>
        </el-form>

        <div class="table">
            <div class="table-header" v-if="$store.state.user.userInfo.type !== $api.account.types.SCHOOL_ADMIN.value">
                <div _flex="~">
                    <el-button type="primary" @click="; (scopeType = 'new'), (newVisible = true)" size="small"
                        v-if="
                            ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
                            ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
                            ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2) ||
                            ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1) && $permissions([`QP2000_${yy_ms}_1`])">
                        <i class="el-icon-plus" style="margin-right: 7px;"></i>新建
                    </el-button>
                </div>

                <el-button v-if="
                    (
                        ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
                        ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
                        ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2) ||
                        ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1) && $permissions([`QP2000_${yy_ms}_5`])
                    ) && multipleSelection.length >= 1
                " @click="removeAllRemindDesc" size="small" :disabled="multipleSelection.length <= 0"
                    :style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'">
                    <i class="el-icon-delete" style="margin-right: 7px;"></i>批量删除
                </el-button>
            </div>

            <el-table :data="tableData" stripe style="width: 100%; min-height: 570px;"
                @selection-change="handleSelectionChange" ref="multipleTable">
                <el-table-column type="selection" width="55" align="center" :key="'selection'" v-if="
                    ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
                    ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
                    $store.state.user.userInfo.type === $api.account.types.RESEARCH.value
                "></el-table-column>
                <!-- 产品要求 -->
                <el-table-column label="编号" prop="id" :show-overflow-tooltip="true" width="60px">
                    <template slot-scope="{ $index }">
                        {{ $index + 1 + page_size * (page - 1) }}
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="title" align="left">
                    <template slot-scope="{ row }">
                        <el-tooltip placement="top-start" effect="light" :content="row.title">
                            <div>
                                {{ row.title.length > 12 ? row.title.substr(0, 12) + '...' : row.title }}
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="出版社" prop="publisher_id" align="left" width="120px">
                    <template slot-scope="{ row }">
                        {{`${publisherIdTags.find(item => item.id == row.publisher_id)?.name}`}}
                    </template>
                </el-table-column>
                <el-table-column label="关联教材" prop="textbook" align="left" width="250px" :show-overflow-tooltip="true">
                    <template slot-scope="{ row }">
                        {{
                            `${row?.textbook?.text_name} / ${filteName(row?.textbook?.text_classgrade, all_grade)} /
                        ${filteLabel(
                                row?.textbook?.text_volume,
                                fb_apply_volume
                            )}`
                        }}
                    </template>
                </el-table-column>
                <el-table-column label="目录" prop="directory.direct_name" align="left"></el-table-column>
                <el-table-column label="创建人" prop="account.realname" align="left"></el-table-column>
                <el-table-column label="操作" align="center"
                    v-if="$permissions([`QP2000_${yy_ms}_2`, `QP2000_${yy_ms}_3`, `QP2000_${yy_ms}_4`])">
                    <template slot-scope="{ row }">
                        <div style="display: flex; justify-content: center;">
                            <!-- <el-tooltip placement="top" effect="light" v-if="$permissions([QP2000_yy_3]) || tabId == 0"> -->
                            <el-tooltip placement="top" effect="light" v-permission="`QP2000_${yy_ms}_2`">
                                <div slot="content">查看</div>
                                <div class="icon-circle" style="background: white;" _border="1px solid [#ebeef5]"
                                    @click="routePush(row)">
                                    <i class="el-icon-view" style="color: #ff7143;"></i>
                                </div>
                            </el-tooltip>
                            <el-tooltip placement="top" effect="light" v-if="
                                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
                                ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
                                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
                                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`QP2000_${yy_ms}_3`]))
                            ">
                                <div slot="content">编辑</div>
                                <div class="icon-circle" style="color: #3f6af7; background: white;"
                                    _border="1px solid [#ebeef5]" @click="; (scopeType = 'edit'), editParamsEvent(row)">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-iconoutlinesetting"></use>
                                    </svg>
                                    <!-- <i class="el-icon-edit-outline" style="color: #3f6af7;"></i> -->
                                </div>
                            </el-tooltip>

                            <el-tooltip placement="top" effect="light" v-if="
                                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
                                ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
                                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
                                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`QP2000_${yy_ms}_4`]))
                            ">
                                <div slot="content">删除</div>
                                <div class="icon-circle" @click="deleteParamsEvent(row)">
                                    <!-- <i class="el-icon-delete" style="color: #ff1f1f;"></i> -->
                                    <svg class="icon" aria-hidden="true"
                                        style="width: 100%; height: 100%; outline: none; box-shadow: none;">
                                        <use xlink:href="#icon-deltred"></use>
                                    </svg>
                                </div>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <div>总计：{{ total }}条/{{ last_page }}页</div>
                <el-pagination :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="page_size"
                    :total="total" background layout="prev, pager, next, jumper, sizes, slot"
                    @current-change="handleCurrentChange" @size-change="handleSizeChange"
                    :key="`${paginationKey}_${tabId}`">
                </el-pagination>
            </div>
        </div>
        <el-dialog class="scope-dialog" :width="'80%'" :before-close="beforeNewClose" :close-on-click-modal="false"
            :visible="newVisible" @close="beforeNewClose" top="5vh" :title="`${scopeType == 'new' ? '新建' : '编辑'}教案`">
            <el-divider></el-divider>
            <el-form :model="newParams" :rules="paramsRules" ref="newParams" label-width="100px">
                <el-form-item label="名称：" prop="title">
                    <InputTopTip v-model="newParams.title" placeholder="名称">
                        <el-input v-model="newParams.title" oninput="value=value.trim()" size="small" class="width-264"
                            :maxlength="25" placeholder=""></el-input>
                    </InputTopTip>
                </el-form-item>
                <el-form-item label="出版社：" prop="publisher_id">
                    <InputTopTip v-model="newParams.publisher_id" placeholder="出版社">
                        <el-select v-model="newParams.publisher_id" size="small" placeholder="" class="width-166"
                            @change="scopeChange($event, '出版社')">
                            <el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </InputTopTip>
                </el-form-item>
                <el-form-item label="关联教材：" prop="c" v-if="newParams.publisher_id">
                    <InputTopTip v-model="newParams.c" placeholder="关联教材">
                        <el-select v-model="newParams.c" size="small" placeholder="" class="width-166"
                            @change="scopeChange($event, '教材')">
                            <el-option v-for="item in textbook" :key="item.id" :label="item.text_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </InputTopTip>
                </el-form-item>
                <el-form-item label="目录：" prop="dict_ids" v-if="newParams.c">
                    <InputTopTip v-model="newParams.dict_ids" placeholder="目录">
                        <el-cascader v-model="newParams.dict_ids" :props="{
                            value: 'id',
                            label: 'direct_name',
                            expandTrigger: 'click'
                        }" :options="scopeOptions" :show-all-levels="false" placeholder="" size="small" class="width-166"
                            @change="scopeChange($event, '目录')"></el-cascader>
                    </InputTopTip>
                </el-form-item>
                <el-form-item label="教案：" prop="body">
                    <div style="border: 1px solid #ccc;">
                        <Toolbar :editor="editor" style="border-bottom: 1px solid #ccc" />
                        <Editor style="height: 500px; overflow-y: hidden;" v-model="newParams.body" :editor="editor"
                            :defaultConfig="editorConfig" @onCreated="onCreated" @onChange="onChange" />
                    </div>
                </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <div
                style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
                <el-button class="btn-close" @click="newVisible = false"
                    style="width: 80px; height: 32px; line-height: 1px;">取
                    消</el-button>
                <el-button class="btn-prim" type="primary" @click="boxConfirmEvent('newParams')"
                    style="width: 80px; height: 32px; line-height: 1px;">确定</el-button>
            </div>
        </el-dialog>
        <!-- 资源查看 -->
        <el-dialog custom-class="video-dialog" :show-close="false" :visible.sync="audioFlag" :append-to-body="true"
            :width="'350px'" top="40vh">
            <div
                style="display: flex; justify-content: center; z-index: 2099; position: relative; margin-bottom: 10px;">
                <i class="el-icon-close" _cursor="pointer"
                    style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
                    @click="audioFlag = false"></i>
                <audio @click.stop controls :src="audioResource" controlslist="noplaybackrate nodownload"></audio>
            </div>
        </el-dialog>
        <el-dialog custom-class="video-dialog" :show-close="false" :visible.sync="videoFlag" :append-to-body="true"
            :width="'509px'" top="32vh">
            <div
                style="display: flex; justify-content: center; align-items: center; z-index: 2099; position: relative;">
                <i class="el-icon-close" _cursor="pointer"
                    style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
                    @click="videoFlag = false"></i>
                <video @click.stop controls width="500" :src="videoResource"
                    controlslist="noplaybackrate nodownload"></video>
            </div>
        </el-dialog>
        <el-dialog :show-close="false" :visible.sync="imgFlag" :append-to-body="true" width="620px">
            <div style="display: flex; justify-content: center; padding: 10px; z-index: 2099; position: relative;">
                <i class="el-icon-close" _cursor="pointer"
                    style="position: absolute; top: -20px; right: -18px; font-size: 20px;" @click="imgFlag = false"></i>
                <img :src="imgResource" style="max-width: 600px; max-height: 900px;" />
            </div>
        </el-dialog>
        <!-- 进度条 -->
        <div v-if="progress.visible"
            style="z-index:9999;width: 100%;height: 100%;position: fixed;left: 0;top: 0;background: rgba(74, 74, 74, 0.4)"
            @click.stop>
            <div _pos="fixed" _z="2009" style="top:50%;left:50%;transform: translate(-50%, -50%);z-index:4000"
                _w="250px">
                <div _text="20px [#ff5e2a] bolder" _m="b-10px"><i class="el-icon-loading" _m="r-5px" />{{ progress.msg
                    }}</div>
                <el-progress :percentage="Number(progress.num)" _h="40px" :stroke-width="18"
                    :text-inside="true"></el-progress>
            </div>
        </div>
    </div>
</template>
<script>
import {
    fileType, fb_apply_volume, primarySchool, middleSchool, highSchool, all_grade, adminIdentity,
    teacherIdentity,
    schoolIdentity,
    researchIdentity
} from './const.js'
import { last, throttle, mapValues } from 'lodash'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { httpRequest } from './UploadEvent.js'
export default {
    components: { Editor, Toolbar },
    data() {
        return {
            progress: {
                num: 0,
                visible: false,
                msg: '正在上传中...'
            },
            progressTimer: null,
            editorConfig: {
                height: '500',
                placeholder: '',
                MENU_CONF: {
                    uploadImage: {
                        allowedFileTypes: ['.jpeg', '.jpg', '.png', '.gif', '.svg',  '.webp'],
                        customUpload: async (file, insertFn) => {
                            try {
                                this.progress.num = 0
                                this.progress.visible = true
                                const { uri } = await httpRequest(file, this.$api3.question_set.upload)
                                insertFn(uri)
                                this.progress.num = 100
                                await new Promise(resolve => setTimeout(resolve, 500))
                                this.progress.visible = false
                            } catch (_) {
                                this.progress.visible = false
                            }
                        }
                    },
                    uploadVideo: {
                        allowedFileTypes: ['.mp4', '.webm', '.ogv', '.m4v'],
                        customUpload: async (file, insertFn) => {
                            try {
                                this.progress.num = 0
                                this.progress.visible = true
                                const { uri } = await httpRequest(file, this.$api3.question_set.upload)
                                insertFn(uri)
                                this.progress.num = 100
                                await new Promise(resolve => setTimeout(resolve, 500))
                                this.progress.visible = false
                            } catch (_) {
                                this.progress.visible = false
                            }
                        }
                    },
                }
            },
            editor: null,
            adminIdentity,
            teacherIdentity,
            schoolIdentity,
            researchIdentity,
            identity: [],
            publisherIdTags: [],
            textbook: [],
            scopeOptions: [],
            dictIdTags: [],
            textbookTags: [],
            paramsRules: {
                title: [{ required: true, message: '名称不能为空', trigger: ['blur', 'change'] }],
                publisher_id: [{ required: true, message: '请选择出版社', trigger: ['blur', 'change'] }],
                c: [{ required: true, message: '请选择教材', trigger: ['blur', 'change'] }],
                dict_ids: [{ required: true, message: '请选择目录', trigger: ['blur', 'change'] }],
                body: [{ required: true, message: '请编辑文本', trigger: ['blur', 'change'] }]
            },
            newParams: {
                title: '',
                publisher_id: '',
                c: '',
                dict_ids: [],
                body: ''
            },
            form: {
                title: '',
                publisher_id: '',
                textbook_id: '',
                dict_ids: []
            },
            page: 1,
            page_size: 10,
            fileList: [],
            fileType,
            lookVisible: false,
            newVisible: false,
            scopeType: 'new',
            imgFlag: false,
            audioFlag: false,
            videoFlag: false,
            videoResource: '',
            audioResource: '',
            imgResource: '',
            primarySchool,
            middleSchool,
            highSchool,
            fb_apply_volume,
            all_grade,
            last_page: '',
            total: 0,
            tabs: [],
            tabs_teacher: [],
            activeId: null,
            tabId: 1,
            tableData: [],
            multipleSelection: [],
            row: {},
            loading: false,
            paginationKey: new Date().getTime(),
            vModelChangeVisible: true
        }
    },
    async created() {
    },
    watch: {
        $route: {
            handler(val) {
                const { sbid } = this.$route.params
                this.activeId = sbid
                this.initPage()
            },
            immediate: true,
            deep: true
        },
        progress: {
            handler(vla) {
                if (vla.visible) {
                    this.progressTimer = setInterval(() => {
                        if (vla.num >= 99) {
                            clearInterval(this.progressTimer)
                        } else {
                            vla.num += 1
                        }
                    }, 1000)
                } else {
                    vla.num = 99
                    clearInterval(this.progressTimer)
                }
            },
            deep: true
        }
    },
    methods: {
        // httpRequest2(file) {
        // 	httpRequest(file)
        // },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
        },
        onChange(editor) {
            console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
        },
        handlePrivateClick(e) {
            this.getSearchParams(e)
            this.getRemindDesc()
        },
        async initPage() {
            await this.getPublisherId()
            const userInfo = this.$store.state.user.userInfo
            if (userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
                this.identity = this.schoolIdentity
            } else if (userInfo.type === this.$api.account.types.TEACHER.value) {
                this.identity = this.teacherIdentity
            } else if (userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
                this.identity = this.adminIdentity
            } else if (userInfo.type === this.$api.account.types.RESEARCH.value) {
                this.identity = this.researchIdentity
            } else {
                this.identity = this.adminIdentity
            }
            // await this.getSubjectData()
            // this.tabId = this.$store.state.searchParams[`${this.$route.name}`]
            // if (this.tabId == undefined) { this.tabId = 1 }
            this.form = mapValues(this.form, () => '')
            this.getSearchParams()
            this.getRemindDesc()
        },
        async getSearchParams(top = undefined) {
            this.vModelChangeVisible = true
            const searchParams = this.$store.state.searchParams[`${this.$route.name}_${this.activeId}`]
            if (top != undefined) {
                this.tabId = top
                this.page = searchParams[top]?.page || 1
                this.page_size = searchParams[top]?.page_size || 10
                this.form.title = searchParams[top]?.title
                this.form.publisher_id = searchParams[top]?.publisher_id
                this.form.textbook_id = searchParams[top]?.textbook_id
                this.form.dict_ids = searchParams[top]?.dict_ids
            } else {
                try {
                    const { historyTop } = searchParams
                    this.tabId = historyTop
                    this.page = searchParams[historyTop]?.page || 1
                    this.page_size = searchParams[historyTop]?.page_size || 10
                    this.form.title = searchParams[historyTop]?.title
                    this.form.publisher_id = searchParams[historyTop]?.publisher_id
                    this.form.textbook_id = searchParams[historyTop]?.textbook_id
                    this.form.dict_ids = searchParams[historyTop]?.dict_ids
                } catch (err) {
                    console.log('正常~')
                    this.tabId = this.identity[0]?.id
                    this.page = 1
                    this.page_size = 10
                }
            }
            setTimeout(() => {
                this.vModelChangeVisible = false
            }, 0)
            this.paginationKey = new Date().getTime()

            // select是动态的、需要保存额外字段
            if (this.form.publisher_id) {
                await this.getTextbooks(this.form.publisher_id, 'textbookTags')
                if (this.form.textbook_id) {
                    let book = this.textbookTags.find(item => item.id == this.form.textbook_id)
                    const options = this.removeEmptyItems(book?.directory, 'children')
                    this.dictIdTags = options
                }
            }
        },
        resourceVisibleClick(item) {
            switch (this.newParams.file_type) {
                case 'image' | 1:
                    this.imgResource = item.uri
                    this.imgFlag = true
                    break
                case 'audio' | 2:
                    this.audioResource = item.uri
                    this.audioFlag = true
                    break
                case 'video' | 3:
                    this.videoResource = item.uri
                    this.videoFlag = true
                    break
                default:
            }
        },
        beforeNewClose() {
            this.newVisible = false
            this.newParams = { title: '', publisher_id: '', c: '', dict_ids: [], file_type: '', path: [] }
            this.$refs['newParams'].resetFields()
        },
        boxConfirmEvent: throttle(function () {
            console.log(this.newParams, '----')
            this.$refs['newParams'].validate(async valid => {
                if (valid) {
                    if (this.scopeType == 'new') {
                        await this.$api.resource.addRemindDesc({
                            ...this.newParams,
                            is_private: this.tabId,
                            subject_id: this.activeId,
                            dict_id: this.newParams.dict_ids[this.newParams.dict_ids.length - 1]
                        })
                        this.$message.success('新建成功，请刷新数据')
                    } else if (this.scopeType == 'edit') {
                        await this.$api.resource.editRemindDesc(this.row.id, {
                            ...this.newParams,
                            subject_id: this.activeId,
                            dict_id: this.newParams.dict_ids[this.newParams.dict_ids.length - 1]
                        })
                        this.$message.success('更新成功，请刷新数据')
                    }
                    this.getRemindDesc()
                    this.beforeNewClose()
                } else {
                    return false
                }
            })
        }, 3000),
        async editParamsEvent(row) {
            this.row = row
            // const data = await this.$api.resource.getFileStorageDetail(row.id)
            const data = row
            await this.getTextbooks(data.textbook.publisher_id)
            let book = this.textbook.find(item => item.id == data.textbook_id)
            const options = this.removeEmptyItems(book?.directory, 'children')
            this.scopeOptions = options
            this.newParams = {
                c: data.textbook_id,
                ...data
            }
            this.newVisible = true
        },
        async getRemindDesc() {
            const params = {
                ...this.form,
                dict_id: last(this.form.dict_ids),
                scope_type: this.tabId,
                subject_id: this.activeId,
                page_size: this.page_size,
                page: this.page
            }
            // this.$store.commit('setTabSearchParams', { key: `${this.$route.name}_${this.tabId}`, top: this.activeId, params: params })
            this.$store.commit('setTabSearchParams', { key: `${this.$route.name}_${this.activeId}`, top: this.tabId, params: params })
            const data = await this.$api.resource.getRemindDesc(params)
            this.tableData = data.data
            this.total = data.meta.total
            this.last_page = data.meta.last_page
        },
        async getPublisherId() {
            const { data } = await this.$api.question_set.getPublisherId({
                fb_subject_id: this.activeId
            })
            this.publisherIdTags = data
        },
        async getTextbooks(publisherId, argsName = 'textbook') {
            const { data } = await this.$api.resource.getTextbooks({
                subject_id: this.activeId,
                publisher_id: publisherId,
                page_size: 99,
                page: 1,
                // scope_type: 0
				scope_type: this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value ? 0 : this.tabId
            })
            this[argsName] = data
        },
        scopeChange(event, type) {
            switch (type) {
                case '出版社':
                    this.$set(this.newParams, 'publisher_id', event)
                    this.$set(this.newParams, 'c', '')
                    this.$set(this.newParams, 'dict_ids', [])
                    this.getTextbooks(event)
                    break
                case '教材': {
                    this.$set(this.newParams, 'c', event)
                    this.$set(this.newParams, 'dict_ids', [])
                    let book = this.textbook.find(item => item.id == event)
                    const options = this.removeEmptyItems(book?.directory, 'children')
                    this.scopeOptions = options
                    break
                }
                case '目录':
                    this.$set(this.newParams, 'dict_ids', event)
                    break
            }
        },
        formChange(event, type) {
            if (this.vModelChangeVisible) return
            switch (type) {
                case '出版社':
                    this.getTextbooks(event, 'textbookTags')
                    this.$set(this.form, 'textbook_id', '')
                    this.$set(this.form, 'dict_ids', [])
                    break
                case '教材': {
                    this.$set(this.form, 'dict_ids', [])
                    let book = this.textbookTags.find(item => item.id == event)
                    const options = this.removeEmptyItems(book?.directory, 'children')
                    this.dictIdTags = options
                    break
                }
                case '目录':
                    console.log(event, '111event')
                    break
            }
            this.getRemindDesc()
        },
        async removeAllRemindDesc() {
            if (this.multipleSelection.length <= 0) return
            this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const params = this.multipleSelection.map(item => {
                        return item.id
                    })
                    await this.$api.resource.removeAllRemindDesc({
                        ids: params
                    })
                    this.page = 1
                    this.getRemindDesc()
                })
                .catch(() => { })
        },
        async twoConfirmClick() {
            this.loading = true
            const data = await this.$api.resource.removeRemindDesc(this.row.id)
            if (data.success) {
                const index = this.multipleSelection.findIndex(item => item.id === this.row.id)
                this.multipleSelection.splice(index, 1)
                this.loading = false
                this.getRemindDesc()
            } else {
                console.log('error')
            }
        },
        deleteParamsEvent(row) {
            this.row = row
            this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.twoConfirmClick()
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleTabClick(e) {
            this.getSearchParams(e)
            this.getRemindDesc()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
            this.form = mapValues(this.form, () => '')
            this.getRemindDesc()
        },
        routePush(row) {
            const params = {
                title: row?.title, // 课件名称
                publisher: row?.publisher?.name, // 出版社名称
                text_name: row?.textbook?.text_name, // 课件名称
                text_classgrade: this.filteName(row?.textbook?.text_classgrade, this.all_grade), // 关联教材年级
                text_volume: this.filteLabel(row?.textbook?.text_volume, this.fb_apply_volume), // 关联教材上下册
                direct_name: row?.directory?.direct_name, // 目录名称
                body: row?.body // 教案富文本
            }
            window.localStorage.setItem('lessonDetailManagement', JSON.stringify(params))
            this.$router.push({
                // path: '/workbench/sourceDetailManagement',
                name: 'lessonDetailManagement',
                query: {
                    id: row.id,
                    scope_type: this.tabId
                }
            })
        },
        // 更改条数
        handleSizeChange(val) {
            this.page = 1
            this.page_size = val
            this.getRemindDesc()
        },
        // 更改页码
        handleCurrentChange(val) {
            this.page = val
            this.getRemindDesc()
        },
        showImage(item) {
            return this.newParams.file_type == 1
                ? item.uri
                : this.newParams.file_type == 3
                    ? item.cover
                    : require('@/assets/image/audio.jpg')
        },
        removeEmptyItems(arr) {
            const newArr = []
            for (let i = 0; i < arr.length; i++) {
                const item = arr[i]
                if (item.children?.length >= 1) {
                    item.children = this.removeEmptyItems(item.children)
                } else {
                    item.children = undefined
                }
                newArr.push(item)
            }
            return newArr
        },
        filteLabel(value, array) {
            if (!value) return
            return array[array.findIndex(item => item.value === value)]?.label || '——'
        },
        filteName(value, array) {
            if (!value) return
            return array[array.findIndex(item => item.val === value)]?.name || '——'
        },
    },
    computed: {
        yy_ms() {
            return this.activeId == 1 ? 'yy' : this.activeId == 2 ? 'ms' : ''
        }
    }
}
</script>
<style scoped lang="scss">
.action-btn:focus {
    background-color: #ff5e2a;
    border-color: #ff5e2a;
    opacity: 1 !important;
}

.tabs-form {
    min-height: 102px;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
}

.table {
    margin-top: 10px;
    padding: 20px;
    background: #ffffff;
    display: block;
}

/deep/ .el-table tbody tr td:last-child {
    padding-right: 0 !important;
}

.table-button {
    margin: 0;
}

.scope-dialog {
    /deep/ .el-dialog .el-dialog__header {
        padding-bottom: 0px;
    }

    .scope-file {
        display: flex;
        flex-wrap: wrap;
        width: 50px;

        img {
            width: 50px;
            object-fit: contain;
        }
    }

    .scope-file-2 {
        display: flex;
        flex-wrap: wrap;
        width: 150px;

        img {
            width: 150px;
            object-fit: contain;
        }
    }
}

.video-dialog {
    margin-top: 25vh;
}

.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 26px;
}

.icon-circle {
    width: 28px;
    height: 28px;
    border-radius: 100%;
    background: #fff8f5;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.icon-circle:nth-child(2) {
    margin-left: 15px;
    margin-right: 15px;
}

.table-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.tabs {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    height: 39px;
    background: #ffffff;
}

.tabs-pane-avtive {
    color: #4a4a4a !important;
    position: relative;
}

.tabs-pane-avtive::after {
    content: '';
    display: block;
    position: absolute;
    top: 38px;
    width: 43px;
    height: 2px;
    background: #ff5e2a;
    border-radius: 0px 0px 0px 0px;
}

.tabs-pane {
    margin-left: 17px;
    margin-right: 8px;
    width: 36px;
    height: 39px;
    font-size: 18px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #bbbbbb;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.form {
    padding: 15px 0px 0px 19px !important;
    display: flex;
    justify-content: space-between;
    min-height: 40px;
    background: #ffffff;
}

.form-contain {
    flex-basis: 80%;

    /deep/ .el-form-item {
        margin-bottom: 12px;
    }
}

.form-reset {
    display: flex;
    flex-wrap: nowrap;
}

.width-166 {
    width: 166px;
}

.width-264 {
    width: 264px;
}

// 少婷提的——表格80
/deep/.el-table thead th {
    background-color: #fafafa;
    border-top: 1px solid #fff;
}
</style>

<style src="@wangeditor/editor/dist/css/style.css"></style>
